import createReducer from '../utils/createReducer';
import {
  HIMS_POSTCODES_REQUEST,
  HIMS_POSTCODES_SUCCESS,
  HIMS_POSTCODES_FAILURE,
} from '../constants/actions';

const initialState = {
  isError: false,
  statusText: null,
  data: [],
  token: null,
};

export default createReducer(initialState, {
  [HIMS_POSTCODES_REQUEST]: state => (
    Object.assign({}, state, {
      isError: false,
    })
  ),
  [HIMS_POSTCODES_SUCCESS]: (state, payload) => (
    Object.assign({}, state, {
      data: [].concat(payload.data),
      token: payload.token,
    })
  ),
  [HIMS_POSTCODES_FAILURE]: (state, payload) => (
    Object.assign({}, state, {
      isError: true,
      statusText: payload.message,
    })
  ),
});



// WEBPACK FOOTER //
// ./src/reducers/himsPostcodes.js